import { useRequest } from 'ahooks'
import { createStyles } from 'antd-style'

import { queryHelpLinkTreeApi } from '@eastcoal/api/content/helpLinkMall/queryHelpLinkTree'

import { RouterLink } from '@eastcoal/router/components/Link'

import { LayoutContainer } from '../../Container'

const useStyles = createStyles(({ token }) => ({
  wrapper: {
    paddingBlock: token.paddingXL,
    backgroundColor: token.colorWhite
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5,1fr)'
  },
  group: {
    display: 'flex',
    justifyContent: 'center',
    [`&+&`]: {
      borderLeft: `1px solid ${token.colorSplit}`
    }
  },
  menu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  title: {
    marginBlockEnd: token.marginXS,
    fontSize: token.fontSizeHeading5,
    color: token.colorPrimaryText
  },
  link: {
    paddingBlock: token.paddingXS
  }
}))

export const HelpLink = () => {
  const { data = [] } = useRequest(queryHelpLinkTreeApi, {
    manual: false,
    pollingErrorRetryCount: 3,
    defaultParams: [undefined, { silence: true }]
  })

  const { styles } = useStyles()

  return (
    <div className={styles.wrapper}>
      <LayoutContainer className={styles.container}>
        {data.map(({ title, children = [] }) => (
          <div key={title} className={styles.group}>
            <div>
              <div className={styles.title}>{title}</div>
              <div className={styles.menu}>
                {children.map(({ id, title, url = '#' }) => (
                  <RouterLink
                    key={id}
                    newtab
                    className={styles.link}
                    to={url}
                    type='text'
                  >
                    {title}
                  </RouterLink>
                ))}
              </div>
            </div>
          </div>
        ))}
      </LayoutContainer>
    </div>
  )
}
